import React, { useContext, useEffect, useState } from "react"
import * as AppConstants from "../../utility/AppConstants"
import * as Utility from "../../utility/Utility"
import { useHistory } from "react-router-dom"
import save from "save-file"

// REST
import axios from "axios"
// TAB
import Breadcrumb from "../breadcrumb/Breadcrumb"
import NotaMetodologicaPDF from "../../../pdf/NTM_Internet_Multianno.pdf"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
import TabRegionaliMultiAnno from "../tab/regionali/multiAnno/TabRegionaliMultiAnno"
import {
    ResponseDatiNazionaliMultiAnno,
    ResponseDatiRegionaliMultiAnno
} from "@/utility/model"
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types"
interface DatiRegionaliProps {
    anno: string
    codIsa?: string
    macroarea?: string
    tipologia?: string
}

function DatiRegionaliMultiAnno(props: DatiRegionaliProps) {
    const history = useHistory()
    const [pdfDisabled, setPdfDisabled] = useState(false)
    const [excelDisabled, setexcelDisabled] = useState(false)
    const [datiRegionali, setDatiRegionali] = useState<
        ResponseDatiRegionaliMultiAnno[]
    >([])
    const [rangeAnni, setRangeAnni] = useState<
        { value: string; label: string }[]
    >([])

    const [multiAnnoState, _] = useContext(MultiAnnoContext)

    let macroArea =
        props.macroarea == undefined || props.macroarea == ""
            ? "@@"
            : props.macroarea

    let codiceIsa =
        props.codIsa == undefined || props.codIsa == "" ? "@@" : props.codIsa

    useEffect(() => {
        const url = AppConstants.URL_GET_DATI_REGIONALI_MULTI_ANNO
        axios
            .get(url, {
                params: {
                    anno: props.anno,
                    codIsa: codiceIsa,
                    macroarea: macroArea
                }
            })
            .then((response) => {
                if (
                    response.data.length !== undefined &&
                    response.data.length > 0
                ) {
                    setDatiRegionali(response.data)

                    let range: number[] = [
                        ...new Set<number>(
                            response.data.map(
                                (el: ResponseDatiNazionaliMultiAnno) => el.anno
                            )
                        )
                    ]

                    let val = {
                        value: range[0].toString(),
                        label: `${range[0]} - ${range[2]}`
                    }
                    setRangeAnni((prevState) => {
                        let cp = [...prevState]
                        cp.push(val)
                        return cp
                    })
                } else {
                    // props.changeUtenteLoggato(response.data)
                    // setUser(null)
                    //history.push("/login")
                }
            })
            .catch((err) => {
                console.log("err: ", err)
            })
        return () => {}
    }, [props, history])

    function getTitle(
        props: Omit<
            DatiRegionaliProps,
            "changeUtenteLoggato" | "tipologia" | "anno"
        >
    ) {
        let title = "Dati Regionali "
        if (props.codIsa !== null && props.codIsa !== undefined)
            title += "Codici ISA"
        else if (props.macroarea !== null && props.macroarea !== undefined)
            title += "Macrosettori"
        else title += "ISA"
        return title
    }

   
   

    let title = getTitle(props)

    return (
        <div className="main-min-vh" role="main">
            <div className="container-fluid py-3 py-md-4">
                <Breadcrumb voce={title} />
                <div className="row">
                    <div className="col-auto">
                        <h1>
                            {title} 
                            { props.macroarea && props.macroarea != ""? " - " + Utility.getValoreHeader(
                                      props.codIsa,
                                      props.macroarea, true
                                  ): ""
                                }
                            
                        </h1>
                    </div>

                    <div className="col">&nbsp;</div>

                    <div className="col-auto">
                        <button
                            // rel="noopener noreferrer"
                            type="button"
                            title="Download EXCEL Dati Nazionali"
                            style={{
                                borderWidth: 0,
                                color: "#06c",
                                opacity: excelDisabled ? 0.6 : 1,
                                backgroundColor: "transparent"
                            }}
                            disabled={excelDisabled}
                            onClick={(e) =>
                                !multiAnnoState.isMultiAnno
                                    ? downloadExcelDatiRegionali(props, e)
                                    : downloadExcelDatiRegionaliMA(
                                          props,
                                          e,
                                          multiAnnoState.chartRefs,
                                          setexcelDisabled
                                      )
                            }
                        >
                            <i className="fas fas fa-file-excel fa-3x mr-2"></i>
                        </button>

                        <button
                            // rel="noopener noreferrer"
                            type="button"
                            title="Download PDF Dati Nazionali"
                            style={{
                                borderWidth: 0,
                                color: "#06c",
                                opacity: pdfDisabled ? 0.6 : 1,
                                backgroundColor: "transparent"
                            }}
                            disabled={pdfDisabled}
                            onClick={(e) =>
                                !multiAnnoState.isMultiAnno
                                    ? downloadPDFDatiRegionali(props, e)
                                    : downloadPDFDatiRegionaliMA(
                                          props,
                                          e,
                                          multiAnnoState.chartRefs,
                                          setPdfDisabled
                                      )
                            }
                        >
                            <i className="fas fas fa-file-pdf fa-3x mr-2"></i>
                        </button>
                    </div>

                    <div className="col-auto">
                        <a
                            aria-hidden="true"
                            href={
                                NotaMetodologicaPDF
                                // process.env.CONTEXT_PATH +
                                // "/resources/pdf/Nota_Metodologica.pdf"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Nota Metodologica"
                        >
                            <span className="fas fa-info-circle fa-3x mr-2"></span>
                        </a>
                    </div>
                </div>

                {datiRegionali !== undefined ? (
                    <TabRegionaliMultiAnno
                        datiRegionali={datiRegionali}
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        anno={props.anno}
                    />
                ) : (
                    <React.Fragment />
                )}
            </div>
        </div>
    )
}

function appendBlob(
    formData: FormData,
    element: HTMLCanvasElement | null,
    index: number,
    chart: HTMLCanvasElement,
    ctx: any
) {
    //ctx?.forEach((e:any) => e?.draw())
    return new Promise<void>((resolve, reject) => {
        element?.toBlob(async (blob) => {
            if (blob != null) {
                formData.append("fileRegion" + (index + 1).toString(), blob)
                console.log("append graph " + (index + 1))

                resolve()
            } else {
                resolve()
            }
        }, "image/jpeg")
    })
}

function downloadPDFDatiRegionali(
    props: DatiRegionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) {
    e.preventDefault()
    let nomePDF = `datiRegionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName("region_chart")
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "fileRegion1",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(0) as Node)
        )
    )
    formData.append(
        "fileRegion2",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(1) as Node)
        )
    )
    formData.append(
        "fileRegion3",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(2) as Node)
        )
    )
    formData.append(
        "fileRegion4",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(3) as Node)
        )
    )
    formData.append(
        "fileRegion5",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(4) as Node)
        )
    )

    axios
        .post(AppConstants.URL_GET_PDF_DATI_REGIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
        })
        .catch((err) => {})
}

async function downloadPDFDatiRegionaliMA(
    props: DatiRegionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ctx: any,
    action: (f: boolean) => void
) {
    e.preventDefault()
    action(true)
    let nomePDF = `datiRegionali_${props.anno}_${Number(props.anno) + 2}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomePDF += "_" + codIsa + ".pdf"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomePDF += "_" + macroarea + ".pdf"
    } else {
        nomePDF += ".pdf"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName(
        "barChart_ChartJs"
    ) as HTMLCollectionOf<HTMLCanvasElement>
    const formData = new FormData()
    formData.append("anno", props.anno)

    let macroArea = macroarea == undefined || macroarea == "" ? "@@" : macroarea

    let codiceIsa = codIsa == undefined || codIsa == "" ? "@@" : codIsa

    formData.append("codIsa", codiceIsa)

    formData.append("macroarea", macroArea)

    for (let i = 0; i < regionChart.length; i++) {
        const element = regionChart.item(i)
        await appendBlob(
            formData,
            element,
            i,
            element as HTMLCanvasElement,
            ctx
        )
    }

    console.log("done")

    axios
        .post(AppConstants.URL_GET_PDF_DATI_REGIONALI_MA_V2, formData, {
            headers: config
        })
        .then((response) => {
            let pdfByte = response.data.pdf
            save(pdfByte, nomePDF)
        })
        .catch((err) => {}).finally(() => action(false))
}

function downloadExcelDatiRegionali(
    props: DatiRegionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) {
    e.preventDefault()
    let nomeExcel = `datiRegionali_${props.anno}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName("region_chart")
    const formData = new FormData()
    formData.append("anno", props.anno)

    if (codIsa !== null && codIsa !== undefined)
        formData.append("codIsa", codIsa)
    if (macroarea !== null && macroarea !== undefined)
        formData.append("macroarea", macroarea)

    formData.append(
        "fileRegion1",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(0) as Node)
        )
    )
    formData.append(
        "fileRegion2",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(1) as Node)
        )
    )
    formData.append(
        "fileRegion3",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(2) as Node)
        )
    )
    formData.append(
        "fileRegion4",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(3) as Node)
        )
    )
    formData.append(
        "fileRegion5",
        Utility.generaSVGGrafico(
            new XMLSerializer().serializeToString(regionChart.item(4) as Node)
        )
    )

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_REGIONALI_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
        })
        .catch((err) => {})
}

async function downloadExcelDatiRegionaliMA(
    props: DatiRegionaliProps,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ctx: any,
    action:(f:boolean) => void
) {
    e.preventDefault()
    action(true)
    let nomeExcel = `datiRegionali_${props.anno}_${Number(props.anno) + 2}`
    let codIsa = props.codIsa
    let macroarea = props.macroarea

    if (codIsa !== null && codIsa !== undefined) {
        nomeExcel += "_" + codIsa + ".xlsx"
    } else if (macroarea !== null && macroarea !== undefined) {
        nomeExcel += "_" + macroarea + ".xlsx"
    } else {
        nomeExcel += ".xlsx"
    }

    const config = AppConstants.HEADER_CONFIG
    const regionChart = document.getElementsByClassName(
        "barChart_ChartJs"
    ) as HTMLCollectionOf<HTMLCanvasElement>
    const formData = new FormData()
    formData.append("anno", props.anno)

    let macroArea = macroarea == undefined || macroarea == "" ? "@@" : macroarea

    let codiceIsa = codIsa == undefined || codIsa == "" ? "@@" : codIsa

    formData.append("codIsa", codiceIsa)

    formData.append("macroarea", macroArea)

    for (let i = 0; i < regionChart.length; i++) {
        const element = regionChart.item(i)
        await appendBlob(
            formData,
            element,
            i,
            element as HTMLCanvasElement,
            ctx
        )
    }

    console.log("done")

    axios
        .post(AppConstants.URL_GET_EXCEL_DATI_REGIONALI_MA_V2, formData, {
            headers: config
        })
        .then((response) => {
            let excelByte = response.data.excel
            save(excelByte, nomeExcel)
    

        })
    
    .catch((err) => {}).finally(() => action(false))
}

export default DatiRegionaliMultiAnno
